import PropTypes from "prop-types";
import { Icon } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useICCCColors } from "../components/theme";
import { categoryMeta } from "../model/constants";

// Devices at this location with a saved x/y — lets an operator verify none
// were placed off-map without having to click each marker individually. In
// Edit Mode, markers themselves are drag-gated (DeviceMarker.js), so this
// row click is the only entry point into the device details popup here.
export default function PlacedDevicesPanel({ devices, onDeviceClick }) {
  const ICCC_COLORS = useICCCColors();

  if (!devices.length) {
    return (
      <MDTypography variant="caption" sx={{ color: ICCC_COLORS.textMuted, display: "block" }}>
        No devices placed on the map yet.
      </MDTypography>
    );
  }

  return (
    <MDBox>
      {devices.map((d) => {
        const meta = categoryMeta(d.category);
        return (
          <MDBox
            key={d.id}
            onClick={() => onDeviceClick(d)}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              p: 0.75,
              mb: 0.5,
              borderRadius: 1,
              bgcolor: ICCC_COLORS.cardBg2,
              cursor: "pointer",
              "&:hover": { bgcolor: ICCC_COLORS.hoverBg },
            }}
          >
            <Icon sx={{ color: ICCC_COLORS[d.health] || ICCC_COLORS.unknown, fontSize: 18 }}>{meta.icon}</Icon>
            <MDBox sx={{ minWidth: 0, flex: 1 }}>
              <MDTypography
                variant="caption"
                sx={{
                  color: ICCC_COLORS.textSecondary,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  display: "block",
                }}
              >
                {d.nodeName || `Asset #${d.id}`}
              </MDTypography>
              <MDTypography variant="caption" sx={{ color: ICCC_COLORS.textMuted, fontSize: 10 }}>
                x {Number(d.xCoordinate).toFixed(1)}% · y {Number(d.yCoordinate).toFixed(1)}%
              </MDTypography>
            </MDBox>
          </MDBox>
        );
      })}
    </MDBox>
  );
}

PlacedDevicesPanel.propTypes = {
  devices: PropTypes.arrayOf(PropTypes.object).isRequired,
  onDeviceClick: PropTypes.func.isRequired,
};
